export class OrganDashboardWidgetAccountBalanceController implements ng.IController {
    public static $inject: string[] = [];
}

export class OrganDashboardWidgetAccountBalanceComponent implements ng.IComponentOptions {
    public bindings = {};
    public template = require('./dashboard-widget-account-balance.html');
    public controller = OrganDashboardWidgetAccountBalanceController;
}
